<template>
  <modal
    :open="modalIsOpen"
    @modal-abort="onAbort"
  >
    <template #title>
      {{ props.messages?.modals?.list_delete?.title }}
    </template>
    <template #default>
      {{ modalBodyText.prefix }} <strong>{{ modalBodyText.name }}</strong> {{ modalBodyText.suffix }}
      <input
        type="hidden"
        id="id"
        :value="props.selectedValue.id"
      />
    </template>
    <template #footer>
      <button
        type="button"
        class="btn btn-outline-default"
        data-dismiss="modal"
        @click="onNo"
      >{{ props.messages?.modals?.list_delete?.button_no }}</button>
      <button
        type="button"
        class="btn btn-primary"
        @click="onYes"
      >{{ props.messages?.modals?.list_delete?.button_yes }}</button>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'

import Modal from '@/components/Modal/Modal.vue'

import { useIO } from '@/composables/io'

interface Props {
  open?: boolean
  messages: any
  urls: any
  bucket: any
  selectedValue: any
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
  messages: undefined,
  urls: undefined,
  bucket: undefined,
  selectedValue: undefined
})

const modalIsOpen = ref(props.open)

const modalBodyText = computed(() => {
  const content = props.messages?.modals?.list_delete?.content
  const contentWithoutStrong = content.replace(/<\/?strong>/g, '')
  const contentParts = contentWithoutStrong.split('{{name}}')
  return { prefix: contentParts[0], suffix: contentParts[1], name: props.selectedValue.text }
})

watch(
  () => props.open,
  (n) => {
    modalIsOpen.value = n
  }
)

const emit = defineEmits(['modal-close'])

const modalClose = (action = 'close', payload = {}) => {
  modalIsOpen.value = false
  emit('modal-close', { action: action, payload: payload })
}

const onAbort = () => {
  modalClose()
}

const onNo = () => {
  modalClose()
}

const onYes = async () => {
  const { performFetchJson } = useIO()

  const data = {
    id: props.selectedValue.id
  }

  const response = await performFetchJson(
    props.urls?.list_delete,
    {
      method: 'POST',
      body: JSON.stringify({ values: data })
    }
  )

  modalClose('yes', response)
}
</script>
